import { render, staticRenderFns } from "./PriceTonModal.vue?vue&type=template&id=8695f014&"
import script from "./PriceTonModal.vue?vue&type=script&lang=js&"
export * from "./PriceTonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports